import React from 'react';
import apiService from '../../services/api';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  styled,
  Typography
} from '@mui/material';
import './DeleteDialog.css';

const deleteImage = apiService.getBlobAssetUrl('Delete_graphic.svg');
const CustomBackdrop = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(8px)', // Apply blur effect
  zIndex: -1, // Ensure it stays behind the dialog content
});

const DeleteDialog = ({ project, onClose, onConfirm }) => {
  const handleConfirm = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onConfirm(project);
    onClose();
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onClose();
  };

  return (
    <Dialog open={!!project} onClose={handleClose} minWidth="600px" fullWidth BackdropComponent={CustomBackdrop}>
      <DialogTitle className="Project-modal-header1">
        Delete
        <button className="Project-close-button11" onClick={handleClose}>
          ×
        </button>
      </DialogTitle>
      <DialogContent>
        <div className="Project-modal-body" style={{ background: 'none'}}>
          <img src={deleteImage} alt="Delete Icon" className="Project-trash-icon" />
          <Typography>
            <p id="delete-41">Are you sure you want to delete the project <span id="delete-6">"{project ? project['Project Name'] : 'Unknown'}"?</span></p>
          </Typography>
        </div>
      </DialogContent>
      <div className="modal-actions1">
            <button onClick={handleClose} id="delete-no">
              No
            </button>
            <button onClick={(e) => handleConfirm(e)} id="edit-10">
              Yes
            </button>
          </div>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'Project Name': PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeleteDialog;